module.exports = __webpack_public_path__ + "f6df108bbb40bc875747ab6f411b5a73.png";